import React from 'react'
import { SecurityOutlined as SecurityIcon } from '@mui/icons-material'

const EMAIL_REGEX = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
const PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

function validateEmail(emailParams) {
    emailParams.value.match(EMAIL_REGEX)
    return false
}

export default function getUserColumns(selectedUser, toggleUser, theme, classes) {
    return [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        {
            field: 'userId',
            headerName: 'Username',
            width: 150,
            editable: true,
        },
        {
            field: 'screenAlias',
            headerName: 'Display Name',
            width: 150,
            editable: true,
        },
        {
            field: 'firstName',
            headerName: 'First',
            width: 150,
            editable: true,
        },
        {
            field: 'lastName',
            headerName: 'Last',
            width: 150,
            editable: true,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 150,
            editable: true,
            preProcessEditCellProps: params => {
                const isValid = validateEmail(params.props.value)
                return { ...params.props, error: !isValid }
            },
        },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 150,
            editable: true,
            validator: value => {
                const valid = value.match(PHONE_REGEX) || value.match(/^$/) || value.match(/^[-]{2}$/)
                if (valid) return true
                return {
                    valid: false,
                    message: 'Please enter a valid phone number',
                }
            },
        },
        {
            field: 'isExternal',
            headerName: 'External Login',
            width: 150,
            editable: false,
            valueFormatter: params => (params.value ? 'Yes' : 'No'),
        },
        {
            field: 'role',
            headerName: 'Role',
            width: 150,
            editable: content => content !== 'Owner',
            style: cell =>
                cell === 'Owner' && {
                    backgroundColor: '#e0e0e0',
                    opacity: '.65',
                    cursor: 'not-allowed',
                },
            editCellStyle: { overflow: 'visible' },
            type: 'singleSelect',
            valueOptions: ['User', 'Super User', 'Admin'],
            attrs: cell => ({ title: cell }),
        },
        {
            field: 'edit',
            headerName: 'Filters',
            classes: 'filter-cell',
            cellClassName: params =>
                (params.row.role === 'Owner' || params.row.role === 'Admin') && 'filter-disabled',
            headerStyle: { flex: '0 0 auto', width: 60 },
            renderCell: params => {
                const onClick = e => {
                    if (params.row.role === 'Owner' || params.row.role === 'Admin') return null
                    return toggleUser(params.row)
                }
                const isSelectedUser = selectedUser && selectedUser.userId === params.row.userId
                return (
                    <SecurityIcon
                        onClick={onClick}
                        fontSize="small"
                        htmlColor={isSelectedUser ? theme.palette.primary.main : '#000'}
                        className={classes.showPointer}
                    />
                )
            },
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            width: 150,
            editable: true,
        },
        {
            field: 'modifiedBy',
            headerName: 'Modified By',
            width: 150,
            editable: true,
        },
    ]
}
